/* ORJN — Search by Photo (serverless, MobileNet in-browser).
 * - downloads the engine + index on load with a visible progress bar; upload is BLOCKED until ready
 * - result images self-heal to the product's current image if an indexed URL is stale
 * - WhatsApp help ALWAYS visible (even on a good match)
 * (No in-page filters.)
 */
(function () {
  var root = document.querySelector('[data-orjn-vs]');
  if (!root) return;

  var cfg = {
    indexUrl: root.getAttribute('data-index-url'),
    whatsapp: (root.getAttribute('data-whatsapp') || '').replace(/[^0-9]/g, ''),
    waMsg: root.getAttribute('data-wa-msg') || '',
    waIdle: root.getAttribute('data-wa-idle') || 'Chat with us on WhatsApp.',
    waWeak: root.getAttribute('data-wa-weak') || "Can't find it? We'll source it — message us on WhatsApp.",
    topN: parseInt(root.getAttribute('data-top-n') || '24', 10),
    indexBytes: parseInt(root.getAttribute('data-index-bytes') || '0', 10),
    preparingLabel: root.getAttribute('data-preparing-label') || 'Getting photo search ready…',
    readyLabel: root.getAttribute('data-ready-label') || 'Ready — upload a shoe photo to search.',
    strong: 0.70,
  };

  var els = {
    input: root.querySelector('[data-orjn-vs-input]'),
    drop: root.querySelector('[data-orjn-vs-drop]'),
    dropText: root.querySelector('[data-orjn-vs-drop-text]'),
    status: root.querySelector('[data-orjn-vs-status]'),
    grid: root.querySelector('[data-orjn-vs-grid]'),
    preview: root.querySelector('[data-orjn-vs-preview]'),
    wa: root.querySelector('[data-orjn-vs-wa]'),
    waText: root.querySelector('[data-orjn-vs-wa-text]'),
    waLink: root.querySelector('[data-orjn-vs-wa-link]'),
    prep: root.querySelector('[data-orjn-vs-prep]'),
    prepLabel: root.querySelector('[data-orjn-vs-prep-label]'),
    prepPct: root.querySelector('[data-orjn-vs-prep-pct]'),
    prepBar: root.querySelector('[data-orjn-vs-prep-bar]'),
  };
  var origDropText = els.dropText ? els.dropText.textContent : '';

  var model = null, index = null, busy = false, ready = false;

  function waHref() { return 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(cfg.waMsg); }
  if (els.waLink) els.waLink.setAttribute('href', waHref());

  function money(v, cur) {
    if (v == null) return '';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD', maximumFractionDigits: 0 }).format(v); }
    catch (e) { return (cur ? cur + ' ' : '$') + v; }
  }
  function matchPct(sim) { return Math.max(1, Math.min(99, Math.round((sim - 0.5) / 0.45 * 100))); }
  function setStatus(t) { if (els.status) els.status.textContent = t || ''; }
  function setWa(mode) { if (!els.wa) return; var weak = mode === 'weak'; if (els.waText) els.waText.textContent = weak ? cfg.waWeak : cfg.waIdle; els.wa.classList.toggle('is-emph', weak); }
  function engineAvailable() { return !!(window.tf && window.mobilenet); }

  // Prefer the WebGPU backend (faster inference on modern phones); fall back to tf.js's default
  // (WebGL) on any device where WebGPU is unavailable or the shim didn't load. Runs once; never throws,
  // so worst case it behaves exactly as before (WebGL). Isolated to this opt-in page.
  var backendReady = null;
  function ensureBackend() {
    if (backendReady) return backendReady;
    backendReady = (async function () {
      var tf = window.tf;
      if (!tf || !tf.setBackend) return;
      try {
        if (navigator.gpu && tf.getBackend() !== 'webgpu') {
          var ok = await tf.setBackend('webgpu'); // resolves false if the webgpu backend isn't registered
          if (!ok) throw new Error('webgpu unavailable');
        }
      } catch (e) {
        try { await tf.setBackend('webgl'); } catch (e2) {}
      }
      try { await tf.ready(); } catch (e) {}
    })();
    return backendReady;
  }

  // ---- Preparation UI (one-time engine + index download; upload is blocked until ready) ----
  function fmtMB(b) { return (b / 1048576).toFixed(1) + ' MB'; }
  function showPrep(on) { if (els.prep) els.prep.hidden = !on; root.classList.toggle('is-preparing', !!on); }
  function setPrepLabel(t) { if (els.prepLabel) els.prepLabel.textContent = t || ''; }
  function setBar(frac) {
    if (!els.prepBar) return;
    var track = els.prepBar.parentNode;
    if (frac == null) { if (track) track.classList.add('is-indeterminate'); return; }
    if (track) track.classList.remove('is-indeterminate');
    els.prepBar.style.width = Math.max(0, Math.min(100, Math.round(frac * 100))) + '%';
  }
  function setPrepPct(t) { if (els.prepPct) els.prepPct.textContent = t || ''; }
  // Real byte progress the shopper can see: "3.2 / 21.0 MB" (+ the bar). getReader yields decompressed
  // bytes, so the total is the uncompressed index size (data-index-bytes) even though it's sent gzipped.
  function setDownload(received, total) {
    setPrepLabel('Downloading photo search');
    if (total > 0) { setBar(Math.min(0.999, received / total)); setPrepPct(fmtMB(received) + ' / ' + fmtMB(total)); }
    else { setBar(null); setPrepPct(fmtMB(received)); }
  }

  // Poll for the CDN engine scripts (they load with `defer`, so may arrive just after this script).
  async function waitForEngine() {
    for (var i = 0; i < 80 && !engineAvailable(); i++) { await new Promise(function (r) { setTimeout(r, 250); }); }
    if (!engineAvailable()) throw new Error('engine-timeout');
  }

  // Stream the index so we can show real download progress. `data-index-bytes` (uncompressed size) is
  // the denominator when present — correct even when the asset is served gzipped (Content-Length would be
  // the compressed size); it falls back to Content-Length, then to an unknown-total MB counter.
  async function loadIndexWithProgress() {
    if (index) return;
    var res = await fetch(cfg.indexUrl, { cache: 'force-cache' });
    if (!res.ok) throw new Error('index-http-' + res.status);
    var total = cfg.indexBytes > 0 ? cfg.indexBytes : (Number(res.headers.get('Content-Length')) || 0);
    var data;
    if (res.body && res.body.getReader) {
      var reader = res.body.getReader(), received = 0, chunks = [];
      setDownload(0, total);
      for (;;) {
        var r = await reader.read();
        if (r.done) break;
        chunks.push(r.value); received += r.value.length;
        setDownload(received, total);
      }
      var buf = new Uint8Array(received), pos = 0;
      for (var i = 0; i < chunks.length; i++) { buf.set(chunks[i], pos); pos += chunks[i].length; }
      data = JSON.parse(new TextDecoder('utf-8').decode(buf));
    } else {
      data = await res.json();
    }
    var scale = data.scale || 127;
    (data.items || []).forEach(function (it) {
      var bin = atob(it.v);
      var f = new Float32Array(bin.length);
      for (var i = 0; i < bin.length; i++) f[i] = ((bin.charCodeAt(i) << 24) >> 24) / scale;
      it.vec = f;
    });
    index = data;
  }

  // Used by run(): by the time a search happens, prepare() has already loaded these. Kept as a guard.
  async function ensureEngine() {
    if (!engineAvailable()) throw new Error('Photo search failed to load. Please refresh.');
    await ensureBackend();
    if (!model) model = await window.mobilenet.load({ version: 2, alpha: 1.0 });
    if (!index) await loadIndexWithProgress();
  }
  function loadModel() {
    return ensureBackend().then(function () {
      if (!model) return window.mobilenet.load({ version: 2, alpha: 1.0 }).then(function (m) { model = m; });
    });
  }

  // One-time setup, eager on page load. Downloads the index with a REAL "X / 21 MB" progress bar and loads
  // the model IN PARALLEL, keeping the uploader disabled until BOTH are ready — then enables it. So the
  // shopper sees genuine byte progress and can only upload once everything's loaded (no mid-load failures).
  async function prepare() {
    showPrep(true); setStatus('');
    if (els.dropText) els.dropText.textContent = cfg.preparingLabel;
    try {
      setPrepLabel('Getting photo search ready…'); setBar(null); setPrepPct('');
      await waitForEngine();
      var modelP = loadModel();                       // load model concurrently
      var indexP = loadIndexWithProgress().then(function () {
        if (!model) { setPrepLabel('Almost ready…'); setBar(null); setPrepPct(''); } // index done, model still loading
      });
      await Promise.all([modelP, indexP]);            // block until BOTH are ready
      setBar(1); setPrepLabel('Almost ready…'); setPrepPct('');
      // Warm-up inference (optional). Fill the canvas — WebGPU throws on an EMPTY one; wrapped so a warm-up
      // failure can NEVER block readiness (model + index are already loaded, all a real search needs).
      try {
        var tf = window.tf;
        var cv = document.createElement('canvas'); cv.width = 224; cv.height = 224;
        var wctx = cv.getContext('2d'); wctx.fillStyle = '#808080'; wctx.fillRect(0, 0, 224, 224);
        await tf.tidy(function () { return model.infer(tf.browser.fromPixels(cv).expandDims(0), true); }).data();
      } catch (warmErr) { /* ignore — warm-up is a nice-to-have */ }
      ready = true;
      showPrep(false);
      if (els.dropText) els.dropText.textContent = origDropText;
      setStatus(cfg.readyLabel);
    } catch (e) {
      // Engine/index couldn't load: keep the uploader disabled, explain, and push the WhatsApp fallback.
      if (els.prep) els.prep.classList.add('is-error');
      showPrep(true);
      setPrepLabel("Photo search couldn't load — please refresh, or use WhatsApp below.");
      setPrepPct(''); setBar(null); setWa('weak');
    }
  }

  function contentBoxOf(img) {
    var scale = Math.min(1, 320 / img.width);
    var W = Math.max(1, Math.round(img.width * scale)), H = Math.max(1, Math.round(img.height * scale));
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    var d; try { d = ctx.getImageData(0, 0, W, H).data; } catch (e) { return null; }
    var bg = [0, 0, 0], corners = [[0, 0], [W - 1, 0], [0, H - 1], [W - 1, H - 1]];
    corners.forEach(function (c) { var i = (c[1] * W + c[0]) * 4; bg[0] += d[i]; bg[1] += d[i + 1]; bg[2] += d[i + 2]; });
    bg[0] /= 4; bg[1] /= 4; bg[2] /= 4;
    var T = 54, minX = W, minY = H, maxX = -1, maxY = -1;
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
      var i = (y * W + x) * 4;
      if (Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) > T) {
        if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y;
      }
    }
    if (maxX < 0) return null;
    var bw = maxX - minX + 1, bh = maxY - minY + 1;
    if (bw > W * 0.9 && bh > H * 0.9) return null;
    if (bw < W * 0.08 || bh < H * 0.08) return null;
    var px = bw * 0.04, py = bh * 0.04;
    return { x: Math.max(0, minX - px) / scale, y: Math.max(0, minY - py) / scale, w: (Math.min(W, maxX + px) - Math.max(0, minX - px)) / scale, h: (Math.min(H, maxY + py) - Math.max(0, minY - py)) / scale };
  }

  async function embedUploadedFile(file) {
    var url = URL.createObjectURL(file);
    try {
      var img = await new Promise(function (resolve, reject) {
        var im = new Image(); im.onload = function () { resolve(im); }; im.onerror = function () { reject(new Error("Couldn't read that image.")); }; im.src = url;
      });
      var tf = window.tf, N = 224;
      var embedRect = async function (sx, sy, sw, sh) {
        var cv = document.createElement('canvas'); cv.width = N; cv.height = N;
        var cx = cv.getContext('2d');
        var s = Math.max(N / sw, N / sh), w = sw * s, h = sh * s;
        cx.drawImage(img, sx, sy, sw, sh, (N - w) / 2, (N - h) / 2, w, h);
        var f = await tf.tidy(function () { var t = tf.browser.fromPixels(cv); var e = model.infer(t.expandDims(0), true).flatten(); return e.div(e.norm().add(1e-8)); }).data();
        return Float32Array.from(f);
      };
      var qvs = [await embedRect(0, 0, img.width, img.height)];
      var box = contentBoxOf(img);
      if (box) qvs.push(await embedRect(box.x, box.y, box.w, box.h));
      return qvs;
    } finally { URL.revokeObjectURL(url); }
  }

  function cardHtml(it, sim) {
    var pct = matchPct(sim), strong = pct >= 70, price = money(it.price, it.currency);
    // The <img> always carries data-orjn-fallback (the product URL) so a stale/missing index image
    // self-heals to the product's CURRENT image (see attachImageFallbacks). The index is a snapshot and
    // Shopify CDN image URLs change as products are re-uploaded; without this, a stale entry renders blank.
    var imgAttrs = 'loading="lazy" alt="" data-orjn-fallback="' + (it.url || '') + '"' + (it.image ? ' src="' + it.image + '"' : '');
    return '<a class="orjn-vs-card" href="' + it.url + '">' +
      '<div class="orjn-vs-card__media"><img ' + imgAttrs + '>' +
      '<span class="orjn-vs-card__match' + (strong ? ' is-strong' : '') + '">' + (strong ? '★ ' : '') + pct + '% match</span></div>' +
      '<div class="orjn-vs-card__title">' + (it.title || '') + '</div>' +
      (price ? '<div class="orjn-vs-card__price">' + price + '</div>' : '') + '</a>';
  }

  // Fetch a product's CURRENT featured image (same-origin, no CORS) and hand it back. Used to repair a
  // result card whose indexed image URL 404s (or is empty) without needing an index rebuild.
  function liveImageFor(purl, cb) {
    if (!purl) return;
    var base = purl.replace(/[?#].*$/, '').replace(/\/+$/, '');
    fetch(base + '.js', { cache: 'force-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var src = p.featured_image || (p.images && p.images[0]);
        if (!src) return;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        cb(src);
      })
      .catch(function () {});
  }
  function attachImageFallbacks() {
    if (!els.grid) return;
    var imgs = els.grid.querySelectorAll('img[data-orjn-fallback]');
    Array.prototype.forEach.call(imgs, function (img) {
      var purl = img.getAttribute('data-orjn-fallback');
      if (!img.getAttribute('src')) { liveImageFor(purl, function (s) { img.src = s; }); return; }
      img.addEventListener('error', function () { liveImageFor(purl, function (s) { img.src = s; }); }, { once: true });
    });
  }

  async function run(file) {
    if (busy || !file || !ready) return; // blocked until the one-time download finishes
    busy = true; root.classList.add('is-busy'); setStatus('Analyzing your photo…');
    if (els.preview) { els.preview.src = URL.createObjectURL(file); els.preview.style.display = 'block'; }
    try {
      await ensureEngine();
      var qvs = await embedUploadedFile(file);
      var items = index.items || [], out = [];
      for (var i = 0; i < items.length; i++) {
        var v = items[i].vec; if (!v) continue;
        var best = -1;
        for (var q = 0; q < qvs.length; q++) { var qv = qvs[q], s = 0, n = Math.min(qv.length, v.length); for (var k = 0; k < n; k++) s += qv[k] * v[k]; if (s > best) best = s; }
        out.push({ it: items[i], sim: best });
      }
      out.sort(function (a, b) { return b.sim - a.sim; });
      var top = out.slice(0, cfg.topN);
      els.grid.innerHTML = top.map(function (r) { return cardHtml(r.it, r.sim); }).join('');
      attachImageFallbacks();
      var best = out.length ? out[0].sim : 0;
      if (best >= cfg.strong) { setStatus('Closest matches to your photo — best first.'); setWa('idle'); }
      else { setStatus('Here are the closest looks we have.'); setWa('weak'); }
    } catch (err) { setStatus((err && err.message) ? err.message : 'Photo search failed.'); setWa('weak'); }
    finally { busy = false; root.classList.remove('is-busy'); }
  }

  if (els.input) els.input.addEventListener('change', function (e) { if (e.target.files && e.target.files[0]) run(e.target.files[0]); });
  if (els.drop) {
    ['dragenter', 'dragover'].forEach(function (ev) { els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.remove('is-over'); }); });
    els.drop.addEventListener('drop', function (e) { var dt = e.dataTransfer; if (dt && dt.files && dt.files[0]) run(dt.files[0]); });
  }

  setWa('idle');
  // Eagerly download the engine + index on load (not on idle): the shopper is here to search, upload is
  // blocked until it's done, and the progress bar tells them what's happening.
  prepare();
})();
